/* Florema · PDP behaviors
   - Gallery: thumb click swaps main image
   - Quantity: −/+ buttons
   - Variant chips: sync hidden select, update price + button text
   - Accordion: native <details> handles itself; we ensure only one open at a time
   - Add to cart: native form submission (Shopify Ajax cart drawer comes from Dawn)
*/

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Smooth scroll para el rating clickeable (★ 4.9 · Ver reseñas)
  ready(function () {
    document.querySelectorAll('[data-florema-pdp-scroll-reviews]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var target = document.getElementById('florema-reviews');
        if (target) {
          e.preventDefault();
          var rect = target.getBoundingClientRect();
          var top  = rect.top + window.pageYOffset - 80;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });
  });

  function formatMoneyFromVariant(amount, currencyFormat) {
    // Shopify exposes variants[].price in cents
    return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 }).format(amount / 100);
  }

  // ── Gallery ────────────────────────────────────────────
  function initGallery(root) {
    var thumbs = root.querySelectorAll('[data-pdp-thumb]');
    var slides = root.querySelectorAll('[data-pdp-slide]');
    if (thumbs.length < 2) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = thumb.getAttribute('data-image-index');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        slides.forEach(function (s) { s.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var slide = root.querySelector('[data-pdp-slide][data-image-index="' + idx + '"]');
        if (slide) slide.classList.add('is-active');
      });
    });
  }

  // ── Quantity stepper ────────────────────────────────────
  function initQty(root) {
    var input = root.querySelector('[data-pdp-qty-input]');
    var minus = root.querySelector('[data-pdp-qty-minus]');
    var plus = root.querySelector('[data-pdp-qty-plus]');
    if (!input) return;

    minus && minus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    plus && plus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // ── Variant selection ──────────────────────────────────
  function initVariants(section) {
    var form = section.querySelector('[data-pdp-form]');
    if (!form) return;
    var radios = form.querySelectorAll('[data-pdp-variant-input]');
    var idSelect = form.querySelector('[data-pdp-id-select]');
    var addBtn = form.querySelector('[data-pdp-add]');
    var addText = form.querySelector('[data-pdp-add-text]');
    var addPrice = form.querySelector('[data-pdp-add-price]');
    var priceEl = section.querySelector('[data-pdp-price]');
    if (!idSelect || !radios.length) return;

    function getSelectedOptions() {
      var values = [];
      var groups = form.querySelectorAll('[data-pdp-variants]');
      groups.forEach(function (g) {
        var checked = g.querySelector('[data-pdp-variant-input]:checked');
        if (checked) values.push(checked.value);
      });
      return values;
    }

    function updateVariant() {
      var values = getSelectedOptions();
      var matching = null;
      var options = idSelect.querySelectorAll('option');

      // Try to find a matching variant via title (Shopify variant.title is values joined with " / ")
      var target = values.join(' / ');
      options.forEach(function (opt) {
        var title = (opt.textContent || '').split(' · ')[0].trim();
        if (title === target) matching = opt;
      });

      if (!matching && options.length) matching = options[0];
      if (!matching) return;

      idSelect.value = matching.value;
      idSelect.dispatchEvent(new Event('change', { bubbles: true }));

      var price = matching.getAttribute('data-price');
      var compare = matching.getAttribute('data-compare-price');
      var available = matching.getAttribute('data-available') === 'true';

      if (priceEl) {
        var priceAmount = priceEl.querySelector('.florema-pdp__price-amount');
        var priceCompare = priceEl.querySelector('.florema-pdp__price-compare');
        if (priceAmount) priceAmount.textContent = price;
        if (priceCompare && compare && compare !== price && compare !== '$0.00' && compare !== '$0') {
          priceCompare.textContent = compare;
          priceCompare.style.display = '';
        } else if (priceCompare) {
          priceCompare.style.display = 'none';
        }
      }

      if (addBtn && addText) {
        if (available) {
          addBtn.removeAttribute('disabled');
          if (addPrice) addPrice.textContent = price;
          else addText.innerHTML = 'Agregar al carro · <span data-pdp-add-price>' + price + '</span>';
        } else {
          addBtn.setAttribute('disabled', 'disabled');
          addText.textContent = 'Agotado';
        }
      }
    }

    radios.forEach(function (r) {
      r.addEventListener('change', updateVariant);
    });
  }

  // ── Same-aroma toggle (packs con 2+ options de aroma) ──
  // Detecta automáticamente cuando un producto tiene 2 o más options con
  // los mismos valores (ej. 2 difusores que comparten lista de aromas).
  // Por default sincroniza ambos al mismo aroma + muestra un toggle
  // "Mismo aroma · RECOMENDADO". Si el usuario lo desactiva, se abren
  // las 2ª, 3ª etc. selecciones para elegir aromas distintos.
  function initSameAromaToggle(section) {
    var form = section.querySelector('[data-pdp-form]');
    if (!form) return;

    var optionWraps = form.querySelectorAll('.florema-pdp__option');
    var groups = form.querySelectorAll('[data-pdp-variants]');
    if (groups.length < 2) return;

    // Verificar que todas las options tengan los mismos values
    var groupKeys = [];
    groups.forEach(function (g) {
      var values = [];
      g.querySelectorAll('[data-pdp-variant-input]').forEach(function (input) {
        values.push((input.value || '').trim().toLowerCase());
      });
      groupKeys.push(values.slice().sort().join('|'));
    });
    var allSame = groupKeys.every(function (k) { return k && k === groupKeys[0]; });
    if (!allSame) return;

    // Inyectar mensaje + toggle después de la 1ª option
    var firstWrap = optionWraps[0];
    if (!firstWrap) return;

    var msg = document.createElement('div');
    msg.className = 'florema-pdp__same-aroma';
    msg.innerHTML =
      '<div class="florema-pdp__same-aroma-info">' +
        '<span class="florema-pdp__same-aroma-text">Mismo aroma para ambos productos</span>' +
        '<span class="florema-pdp__same-aroma-badge">Recomendado</span>' +
      '</div>' +
      '<button type="button" class="florema-pdp__same-aroma-toggle" data-same-aroma-toggle aria-pressed="true" aria-label="Usar mismo aroma">' +
        '<span class="florema-pdp__same-aroma-toggle-track">' +
          '<span class="florema-pdp__same-aroma-toggle-knob"></span>' +
        '</span>' +
      '</button>';
    firstWrap.insertAdjacentElement('afterend', msg);
    /* Florema PACKS: etiqueta "Aroma del PAC" + lamina por aroma (Claude) */
    (function(){
      var __fl = optionWraps[0] && optionWraps[0].querySelector('.florema-pdp__option-label');
      var __flOrig = __fl ? __fl.textContent.trim() : '';
      function __nrm(s){ return (s||'').trim().toLowerCase().split('á').join('a').split('é').join('e').split('í').join('i').split('ó').join('o').split('ú').join('u'); }
      function __packUI(){
        var __t = msg.querySelector('[data-same-aroma-toggle]');
        var __same = !__t || __t.getAttribute('aria-pressed') === 'true';
        if(__fl) __fl.textContent = __same ? 'Aroma del PACK' : __flOrig;
        var __v = [];
        groups.forEach(function(g){ var c = g.querySelector('[data-pdp-variant-input]:checked'); if(c) __v.push(__nrm(c.value)); });
        var __eq = __v.length && __v.every(function(x){ return x === __v[0]; });
        var __ar = __eq ? __v[0] : null;
        var __g = document.querySelector('[data-pdp-gallery]');
        if(!__g) return;
        __g.querySelectorAll('[data-pack-aroma]').forEach(function(el){
          var __m = __ar && __nrm(el.getAttribute('data-pack-aroma')) === __ar;
          el.style.display = __m ? '' : 'none';
          if(__m){ var p = el.parentNode, f = p.firstElementChild; if(f && f !== el && f.nextElementSibling !== el){ p.insertBefore(el, f.nextElementSibling); } }
        });
      }
      groups.forEach(function(g){ g.addEventListener('change', __packUI); });
      var __tb = msg.querySelector('[data-same-aroma-toggle]');
      if(__tb) __tb.addEventListener('click', function(){ setTimeout(__packUI, 0); });
      setTimeout(__packUI, 60);
    })();

    // Ocultar todas las options excepto la primera por default
    for (var i = 1; i < optionWraps.length; i++) {
      optionWraps[i].classList.add('florema-pdp__option--hidden');
    }

    function syncFromFirst() {
      var firstChecked = groups[0].querySelector('[data-pdp-variant-input]:checked');
      if (!firstChecked) return;
      var value = firstChecked.value;

      for (var i = 1; i < groups.length; i++) {
        var inputs = groups[i].querySelectorAll('[data-pdp-variant-input]');
        var found = null;
        inputs.forEach(function (input) {
          if (input.value === value) found = input;
        });
        if (found && !found.checked) {
          found.checked = true;
          found.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    // Cuando cambian la 1ª, replicar a las demás (si toggle activo)
    groups[0].addEventListener('change', function () {
      var toggle = msg.querySelector('[data-same-aroma-toggle]');
      if (toggle && toggle.getAttribute('aria-pressed') === 'true') {
        syncFromFirst();
      }
    });

    // Click en toggle alterna estado
    var toggleBtn = msg.querySelector('[data-same-aroma-toggle]');
    toggleBtn.addEventListener('click', function () {
      var pressed = toggleBtn.getAttribute('aria-pressed') === 'true';
      var next = !pressed;
      toggleBtn.setAttribute('aria-pressed', next ? 'true' : 'false');

      for (var i = 1; i < optionWraps.length; i++) {
        if (next) {
          optionWraps[i].classList.add('florema-pdp__option--hidden');
        } else {
          optionWraps[i].classList.remove('florema-pdp__option--hidden');
        }
      }

      if (next) {
        // Volver al modo "mismo aroma": sync inmediato
        syncFromFirst();
      }
    });

    // Sync inicial
    syncFromFirst();
  }

  // ── Sticky add-to-cart bar ─────────────────────────────
  // Aparece al scrollear bajo el CTA principal y permite agregar
  // sin tener que scrollear de regreso.
  function initStickyAtc(section) {
    var sticky = document.querySelector('[data-pdp-sticky]');
    var ctaRow = section.querySelector('.florema-pdp__cta-row');
    if (!sticky || !ctaRow) return;

    // En escritorio, posicionar la barra justo debajo del header (cuya altura
    // varía si hay banner de envío gratis arriba). En mobile queda abajo.
    function syncTopToHeader() {
      if (window.innerWidth < 750) {
        sticky.style.top = '';
        return;
      }
      var hdr = document.querySelector('.florema-hdr');
      var hdrH = hdr ? hdr.offsetHeight : 110;
      sticky.style.top = hdrH + 'px';
    }
    syncTopToHeader();
    window.addEventListener('resize', syncTopToHeader);

    function updateVisibility() {
      var rect = ctaRow.getBoundingClientRect();
      // Mostrar sticky cuando el CTA principal NO está en pantalla: ya pasó (arriba) o todavía no llega (abajo, al entrar a la ficha en celular)
      if (rect.bottom < 0 || rect.top > window.innerHeight) {
        sticky.classList.add('is-visible');
        sticky.setAttribute('aria-hidden', 'false');
      } else {
        sticky.classList.remove('is-visible');
        sticky.setAttribute('aria-hidden', 'true');
      }
    }

    // Scroll listener (más confiable que IntersectionObserver para este caso)
    var ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          updateVisibility();
          ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // Initial check
    updateVisibility();

    // Click en sticky add → sincroniza qty con form principal y dispara CTA
    var stickyBtn = sticky.querySelector('[data-pdp-sticky-add]');
    var stickyQtyVal = sticky.querySelector('[data-sticky-qty-val]');
    var mainQtyInput = section.querySelector('[data-pdp-qty-input]');

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        // Sincronizar qty al input principal antes de hacer click
        if (stickyQtyVal && mainQtyInput) {
          mainQtyInput.value = stickyQtyVal.textContent || '1';
          mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var mainBtn = section.querySelector('[data-pdp-add]');
        if (mainBtn && !mainBtn.disabled) {
          mainBtn.click();
        }
      });
    }

    // Sticky qty +/-
    var qtyMinus = sticky.querySelector('[data-sticky-qty-minus]');
    var qtyPlus = sticky.querySelector('[data-sticky-qty-plus]');
    if (qtyMinus && stickyQtyVal) {
      qtyMinus.addEventListener('click', function () {
        var v = parseInt(stickyQtyVal.textContent, 10) || 1;
        if (v > 1) stickyQtyVal.textContent = v - 1;
      });
    }
    if (qtyPlus && stickyQtyVal) {
      qtyPlus.addEventListener('click', function () {
        var v = parseInt(stickyQtyVal.textContent, 10) || 1;
        stickyQtyVal.textContent = v + 1;
      });
    }

    // "Cambiar" → scroll suave a los variant chips
    var changeBtn = sticky.querySelector('[data-pdp-sticky-change]');
    if (changeBtn) {
      changeBtn.addEventListener('click', function () {
        var variants = section.querySelector('.florema-pdp__option') ||
                       section.querySelector('.florema-pdp-aromas') ||
                       section.querySelector('.florema-pdp__variants');
        if (variants) {
          variants.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    // Update sticky price + variant name cuando cambia variant
    var hiddenSelect = section.querySelector('[data-pdp-id-select]');
    var stickyPrice = sticky.querySelector('[data-pdp-sticky-price]');
    var stickyVariant = sticky.querySelector('[data-pdp-sticky-variant]');
    // Nombre de producto limpio como fallback (sin prefijos de tipo/tamaño)
    var productTitleClean = (section.getAttribute('data-pdp-product-title') || document.title || '').trim();
    if (hiddenSelect) {
      hiddenSelect.addEventListener('change', function () {
        var selected = hiddenSelect.options[hiddenSelect.selectedIndex];
        if (selected) {
          var price = selected.getAttribute('data-price');
          if (price && stickyPrice) stickyPrice.textContent = price;
          // Variant title is in the option text before " · "
          var label = (selected.textContent || '').split(' · ')[0].trim();
          // Si es "Default Title" (variante sin opciones) usar el nombre del producto limpio
          if (!label || label === 'Default Title') {
            label = stickyVariant ? stickyVariant.textContent : label;
          }
          if (label && stickyVariant) stickyVariant.textContent = label;
        }
      });
    }
  }

  // ── Accordion: only one open at a time (optional) ──────
  function initAccordion(root) {
    var items = root.querySelectorAll('[data-pdp-accordion] > .florema-pdp-accordion__item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        }
      });
    });
  }

  // ── Bulk tiers (descuentos por cantidad) ──
  function initBulkTiers(tiersEl) {
    if (!tiersEl) return;
    var qtyInput = document.querySelector('[data-pdp-qty-input]');
    var qtyWrap  = document.querySelector('[data-pdp-qty]');
    var addBtn   = document.querySelector('[data-pdp-add]');
    var addPriceEl = document.querySelector('[data-pdp-add-price]');
    // Sticky bar (mobile/scroll): sincronizar qty + precio
    var stickyQtyVal = document.querySelector('[data-sticky-qty-val]');
    var stickyQtyWrap = document.querySelector('[data-pdp-sticky-qty]');
    var stickyPriceEl = document.querySelector('[data-pdp-sticky-price]');
    var basePrice = parseInt(tiersEl.dataset.basePrice, 10) || 0;

    function fmtMoney(cents) {
      // formatear como CLP: $X.XXX
      var amount = Math.round(cents / 100);
      return '$' + amount.toLocaleString('es-CL').replace(/,/g, '.');
    }

    function tierTotalCents(qty) {
      if (basePrice <= 0) return 0;
      if (qty === 2) return Math.round(basePrice * 2 * 0.90);
      if (qty === 3) return Math.round(basePrice * 3 * 0.85);
      if (qty === 5) return Math.round(basePrice * 5 * 0.70);
      return basePrice * qty;
    }

    function selectTier(option) {
      var qty = parseInt(option.dataset.tierQty, 10) || 1;

      // Marcar visualmente
      tiersEl.querySelectorAll('[data-florema-tier]').forEach(function (el) {
        el.classList.toggle('is-active', el === option);
      });
      var radio = option.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;

      // Sincronizar cantidad del form
      if (qtyInput) {
        qtyInput.value = qty;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Ocultar el qty +/- mientras se usa el selector de tiers
      // (la cantidad la define el tier — no queremos doble UI)
      if (qtyWrap) qtyWrap.style.display = qty > 1 ? 'none' : '';

      // Actualizar el precio del botón "Agregar al carro" (principal)
      var totalCents = tierTotalCents(qty);
      if (addPriceEl && basePrice > 0) {
        addPriceEl.textContent = fmtMoney(totalCents);
      }

      // Sincronizar el sticky bar (cantidad + precio + ocultar qty +/-)
      if (stickyQtyVal) stickyQtyVal.textContent = qty;
      if (stickyQtyWrap) stickyQtyWrap.style.display = qty > 1 ? 'none' : '';
      if (stickyPriceEl && basePrice > 0) {
        stickyPriceEl.textContent = fmtMoney(totalCents);
      }
    }

    // Click en cada tier
    tiersEl.querySelectorAll('[data-florema-tier]').forEach(function (option) {
      option.addEventListener('click', function (e) {
        // Si clickea sobre el input radio, dejar que él haga lo suyo y no doblamos
        selectTier(option);
      });
    });
  }

  ready(function () {
    document.querySelectorAll('[data-pdp-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-pdp-qty]').forEach(initQty);
    document.querySelectorAll('.florema-pdp').forEach(initVariants);
    document.querySelectorAll('.florema-pdp').forEach(initSameAromaToggle);
    document.querySelectorAll('.florema-pdp').forEach(initStickyAtc);
    document.querySelectorAll('.florema-pdp-accordion-wrap').forEach(initAccordion);
    document.querySelectorAll('[data-florema-pdp-tiers]').forEach(initBulkTiers);
  });
})();
